import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import SidebarMenu from './components/sidebarMenu/SidebarMenu';
import TopBar from './components/topBar/TopBar';
import { useUserTokens } from '@/common/hooks/useTokens';
import { useMobileViewportHeight } from '@/common/hooks/useMobileViewportHeight';
import { ProductContext } from './ProductContext';
import { useGuestAuth } from '@/common/contexts/GuestAuthContext';
import { AppShell, Main } from './ProductLayout.styles';

const SCROLL_LOCKED_PREFIXES = ['/chat', '/studio', '/discover'];

const isScrollLockedRoute = (pathname) =>
	SCROLL_LOCKED_PREFIXES.some(
		(prefix) => pathname === prefix || pathname.startsWith(`${prefix}/`),
	);

const ProductLayout = ({ children }) => {
	const { pathname } = useLocation();
	const scrollLocked = isScrollLockedRoute(pathname);
	const { isLoggedIn } = useGuestAuth();
	const { tokenCount, isLoading, handleGetTokens } = useUserTokens(isLoggedIn);

	useMobileViewportHeight();

	useEffect(() => {
		if (scrollLocked) {
			document.documentElement.dataset.productScroll = 'locked';
		} else {
			delete document.documentElement.dataset.productScroll;
		}

		return () => {
			delete document.documentElement.dataset.productScroll;
		};
	}, [scrollLocked]);

	return (
		<AppShell>
			<ProductContext.Provider
				value={{
					tokenCount,
					isLoading,
					handleGetTokens,
				}}
			>
				<TopBar />
				<SidebarMenu />
				<Main data-scroll={scrollLocked ? 'locked' : 'main'}>{children}</Main>
			</ProductContext.Provider>
		</AppShell>
	);
};

export default ProductLayout;
